import { createEffect, sample } from 'effector';
import $$api from 'models/api';
import $$auth from 'models/auth';
import $$ep from 'models/ep';

import { type QuestionnaireInstance, QuestionnaireInstanceZod } from 'types/zod/questionnaire-instance';

// When state is updated, fetch new qInstances
sample({
    source: {
        old: $$auth.$currentParticipant.map((p) => p?.address?.domicile?.state_code),
        qInstanceId: $$ep.stores.$epQInstanceId,
    },
    clock: $$api.participants.updateParticipantFx.done.map(({ params }) => params?.address?.domicile?.state_code),
    filter: ({ old, qInstanceId }, updated) => old !== updated && qInstanceId !== null,
    fn: ({ qInstanceId }) => QuestionnaireInstanceZod.shape.questionnaire_instance_id.parse(qInstanceId),
    target: createEffect((qInstanceId: QuestionnaireInstance['questionnaire_instance_id']) => {
        $$api.qInstances.getQInstanceFx(qInstanceId);
        $$api.answers.getAnswersFx({ id: qInstanceId });
    }),
});
